import { ArrowRight } from "@/components/icons";
import { Button } from "@/components/ui/button";

interface TradeBottomCtaViewProps {
  intent: "sell" | "recycle";
  pluralName: string;
  onStart: () => void;
}

export function TradeBottomCtaView({ intent, pluralName, onStart }: TradeBottomCtaViewProps) {
  const heading =
    intent === "sell"
      ? `Ready to Sell Your ${pluralName}?`
      : `Ready to Recycle Your ${pluralName}?`;

  return (
    <section className="border-y border-border bg-muted">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:justify-between sm:text-left">
          <h2 className="text-lg font-bold text-foreground">{heading}</h2>
          <Button variant="primary" size="default" onClick={onStart}>
            Get Started
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}
